//# sourceMappingURL=button.mjs.map
/// <reference types="./button.d.mts" />
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $attribute from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $html from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../ds/colors.mjs";
import * as $text from "../../ds/typography/text.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Links extends $CustomType {
  constructor(primary, secondary, text) {
    super();
    this.primary = primary;
    this.secondary = secondary;
    this.text = text;
  }
}
export const Links$Links = (primary, secondary, text) =>
  new Links(primary, secondary, text);
export const Links$isLinks = (value) => value instanceof Links;
export const Links$Links$primary = (value) => value.primary;
export const Links$Links$0 = (value) => value.primary;
export const Links$Links$secondary = (value) => value.secondary;
export const Links$Links$1 = (value) => value.secondary;
export const Links$Links$text = (value) => value.text;
export const Links$Links$2 = (value) => value.text;

export class Classes extends $CustomType {
  constructor(base, pill, primary, secondary) {
    super();
    this.base = base;
    this.pill = pill;
    this.primary = primary;
    this.secondary = secondary;
  }
}
export const Classes$Classes = (base, pill, primary, secondary) =>
  new Classes(base, pill, primary, secondary);
export const Classes$isClasses = (value) => value instanceof Classes;
export const Classes$Classes$base = (value) => value.base;
export const Classes$Classes$0 = (value) => value.base;
export const Classes$Classes$pill = (value) => value.pill;
export const Classes$Classes$1 = (value) => value.pill;
export const Classes$Classes$primary = (value) => value.primary;
export const Classes$Classes$2 = (value) => value.primary;
export const Classes$Classes$secondary = (value) => value.secondary;
export const Classes$Classes$3 = (value) => value.secondary;

export class Attributes extends $CustomType {
  constructor(size, tiny, small, medium) {
    super();
    this.size = size;
    this.tiny = tiny;
    this.small = small;
    this.medium = medium;
  }
}
export const Attributes$Attributes = (size, tiny, small, medium) =>
  new Attributes(size, tiny, small, medium);
export const Attributes$isAttributes = (value) => value instanceof Attributes;
export const Attributes$Attributes$size = (value) => value.size;
export const Attributes$Attributes$0 = (value) => value.size;
export const Attributes$Attributes$tiny = (value) => value.tiny;
export const Attributes$Attributes$1 = (value) => value.tiny;
export const Attributes$Attributes$small = (value) => value.small;
export const Attributes$Attributes$2 = (value) => value.small;
export const Attributes$Attributes$medium = (value) => value.medium;
export const Attributes$Attributes$3 = (value) => value.medium;

export class Tiny extends $CustomType {}
export const Size$Tiny = () => new Tiny();
export const Size$isTiny = (value) => value instanceof Tiny;

export class Small extends $CustomType {}
export const Size$Small = () => new Small();
export const Size$isSmall = (value) => value instanceof Small;

export class Medium extends $CustomType {}
export const Size$Medium = () => new Medium();
export const Size$isMedium = (value) => value instanceof Medium;

const transitions = /* @__PURE__ */ toList([
  "background .3s",
  "color .3s",
  "border .3s",
  "margin-right .3s",
  "gap .3s",
]);

export const links = /* @__PURE__ */ new Links(
  primary_link,
  secondary_link,
  text_link,
);

export const classes = /* @__PURE__ */ new Classes(
  base_st,
  pill_st,
  primary_st,
  secondary_st,
);

export const attributes = /* @__PURE__ */ new Attributes(
  size,
  tiny,
  small,
  medium,
);

export function text(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(base_st()),
      $css.background($colors.light.transparent),
      $css.color(
        ("var(--text-button-color, " + $colors.light.text_display) + ")",
      ),
      $css.hover(toList([$css.gap(px(18)), $css.margin_right(px(-6))])),
      $css.selector(
        "[data-static=true]",
        toList([$css.margin_right(px(0)), $css.gap(px(12))]),
      ),
      $css.disabled(
        toList([
          $css.color($colors.light.grey_800),
          $css.cursor("not-allowed"),
          $css.gap(px(6)),
        ]),
      ),
    ]),
  );
  return $html.button(_pipe, attrs, children);
}

function base_st() {
  return $css.class$(
    toList([
      $css.position("relative"),
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.gap(px(8)),
      $css.cursor("pointer"),
      $css.transition($string.join(transitions, ", ")),
      $css.appearance("none"),
      $css.border("none"),
      $css.outline("none"),
      $css.overflow("hidden"),
      $css.font_family("inherit"),
      $css.compose($text.sm($text.medium)),
      $css.selector(
        "[data-size=tiny]",
        toList([$css.compose($text.xs($text.medium))]),
      ),
      $css.selector(
        "[data-size=small]",
        toList([$css.compose($text.xs($text.medium))]),
      ),
      $css.selector(
        "[data-size=medium]",
        toList([$css.compose($text.sm($text.medium))]),
      ),
    ]),
  );
}

function pill_st() {
  return $css.class$(
    toList([
      $css.compose(base_st()),
      $css.border_radius(px(8)),
      $css.text_decoration("none"),
      $css.border("1px solid " + $colors.light.text_display),
      $css.flex_shrink(0.0),
      $css.padding_("8px 20px"),
      $css.selector("[data-size=tiny]", toList([$css.padding_("2px 4px")])),
      $css.selector("[data-size=small]", toList([$css.padding_("4px 8px")])),
      $css.selector("[data-size=medium]", toList([$css.padding_("8px 20px")])),
    ]),
  );
}

function primary_st() {
  let disabled_style = toList([
    $css.background($colors.light.grey_400),
    $css.color($colors.light.grey_800),
    $css.border("1px solid " + $colors.light.grey_400),
    $css.cursor("not-allowed"),
  ]);
  return $css.class$(
    toList([
      $css.compose(pill_st()),
      $css.background($colors.light.text_display),
      $css.color($colors.light.text_white),
      $css.hover(toList([$css.background($colors.light.text_body)])),
      $css.disabled(disabled_style),
      $css.selector("[disabled]", disabled_style),
    ]),
  );
}

export function primary(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(primary_st())]));
  return $html.button(_pipe, attrs, children);
}

function secondary_st() {
  return $css.class$(
    toList([
      $css.compose(pill_st()),
      $css.background($colors.light.text_white),
      $css.color($colors.light.grey_800),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.hover(
        toList([
          $css.background($colors.light.text_display),
          $css.color($colors.light.text_white),
        ]),
      ),
      $css.disabled(
        toList([
          $css.background($colors.light.text_white),
          $css.color($colors.light.grey_400),
          $css.border("1px solid " + $colors.light.grey_100),
          $css.cursor("not-allowed"),
        ]),
      ),
    ]),
  );
}

export function secondary(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(secondary_st())]));
  return $html.button(_pipe, attrs, children);
}

export function success(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(secondary_st()),
      $css.color($colors.light.success_800),
      $css.hover(toList([$css.background($colors.light.success_800)])),
    ]),
  );
  return $html.button(_pipe, attrs, children);
}

export function ghost(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(pill_st()),
      $css.background($colors.light.transparent),
      $css.color($colors.light.grey_600),
      $css.text_decoration("none"),
      $css.border("none"),
      $css.hover(
        toList([
          $css.background($colors.light.grey_200),
          $css.color($colors.light.text_display),
        ]),
      ),
      $css.disabled(
        toList([
          $css.color($colors.light.grey_800),
          $css.cursor("not-allowed"),
          $css.gap(px(6)),
        ]),
      ),
    ]),
  );
  return $html.a(_pipe, attrs, children);
}

export function inlay(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(pill_st()),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.compose($text.sm($text.medium)),
      $css.padding_("6px 8px"),
      $css.background($colors.light.text_white),
      $css.border_radius(px(4)),
      $css.gap(px(8)),
      $css.color($colors.light.grey_800),
      $css.hover(toList([$css.background($colors.light.grey_100)])),
    ]),
  );
  return $html.button(_pipe, attrs, children);
}

export function static$() {
  return $attribute.attribute("data-static", "true");
}

export function color(color) {
  return $attribute.style(toList([["--text-button-color", color]]));
}

export function content(content) {
  let _pipe = $css.class$(toList([$css.z_index(100)]));
  return $html.div(_pipe, toList([]), toList([$html.text(content)]));
}

function primary_link(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(primary_st())]));
  return $html.a(_pipe, attrs, children);
}

function secondary_link(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(secondary_st())]));
  return $html.a(_pipe, attrs, children);
}

function text_st() {
  return $css.class$(
    toList([
      $css.compose(base_st()),
      $css.background($colors.light.transparent),
      $css.color(
        ("var(--text-button-color, " + $colors.light.text_display) + ")",
      ),
      $css.text_decoration("none"),
      $css.hover(toList([$css.gap(px(18)), $css.margin_right(px(-6))])),
      $css.selector(
        "[data-static=true]",
        toList([$css.margin_right(px(0)), $css.gap(px(12))]),
      ),
      $css.disabled(
        toList([
          $css.color($colors.light.grey_800),
          $css.cursor("not-allowed"),
          $css.gap(px(6)),
        ]),
      ),
    ]),
  );
}

function text_link(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose(text_st())]));
  return $html.a(_pipe, attrs, children);
}

function size(size) {
  return $attribute.data(
    "size",
    (() => {
      if (size instanceof Tiny) {
        return "tiny";
      } else if (size instanceof Small) {
        return "small";
      } else {
        return "medium";
      }
    })(),
  );
}

function tiny() {
  return size(new Tiny());
}

function small() {
  return size(new Small());
}

function medium() {
  return size(new Medium());
}
